import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	crossroad11BBlack11BBlack,
	crossroad11DRed11CBlack,
	crossroad11DRed11FBlue,
	crossroad11FBlue11CBlack,
	crossroad11FBlue11DRed,
	crossroad12ARed12DRed,
	crossroad12BBlue12DRed,
	crossroad12CRed12DRed,
	crossroad13ARed13BRed,
	crossroad13ARed13CRed,
	crossroad14ABlue22ABlack,
	crossroad14ABlueSBlue,
	crossroad14BBlue14ABlue,
	crossroad15DRed14BBlue,
	crossroad15EBlue15DRedSBlue,
	crossroad16ARed16BBlack,
	crossroad16ARed16CBlack,
	crossroad16DBlack16CBlack,
	crossroad1CBlue1ARedShow,
	crossroad2CBlue2BRed,
	crossroad9ABlue13BRed,
	crossroad9ABlue13CRed,
	crossroad5ABlue5DRed,
	crossroad5CRedFBlueGBlue5BBlue5ABlue,
	crossroad5KBlue5CRed,
	crossroad5KBlue5EBlack,
	crossroad5KBlue5GRed5FBlack,
	crossroad8BRed8DBlue8CRed,
	crossroad8CRed8DBlue,
	crossroadJBlue13EBlue,
	crossRoad1CBlue1BBlack1EBlue,
	crossroadCondition,
	crossroad11FBlue11ARed
} from "../helpers/conditions";
import CrossRoad_1CBlue_1ARed from "./crossroads/CrossRoad_1CBlue_1ARed";
import CrossRoad_2CBlue_2BRed from "./crossroads/CrossRoad_2CBlue_2BRed";
import CrossRoad5KBlue5GRed from "./crossroads/CrossRoad5KBlue5GRed";
import CrossRoad_5K_5C from "./crossroads/CrossRoad_5K_5C";
import CrossRoad_5ABlue_5DRed from "./crossroads/CrossRoad_5ABlue_5DRed";
import CrossRoad_5CRed_FBlue_GBlue_5BBlue_5ABlue from "./crossroads/CrossRoad_5CRed_FBlue_GBlue_5BBlue_5ABlue";
import CrossRoad_8CRed_8DBlue from "./crossroads/CrossRoad_8CRed_8DBlue";
import CrossRoad_8BRed_8CRed_8DBlue from "./crossroads/CrossRoad_8BRed_8CRed_8DBlue";
import CrossRoad_12ARed_12DRed from "./crossroads/CrossRoad_12ARed_12DRed";
import CrossRoad_12CRed_12DRed from "./crossroads/CrossRoad_12CRed_12DRed";
import CrossRoad_12BBlue_12DRed from "./crossroads/CrossRoad_12BBlue_12DRed";
import CrossRoad_11DRed_11CBlack from "./crossroads/CrossRoad_11DRed_11CBlack";
import CrossRoad_11FBlue_11CBlack from "./crossroads/CrossRoad_11FBlue_11CBlack";
import CrossRoad11FBlue11ARed from "./crossroads/CrossRoad11FBlue11ARed";
import CrossRoad_11DRed_11FBlue from "./crossroads/CrossRoad_11DRed_11FBlue";
import CrossRoad_11CBlack_11BBlack from "./crossroads/CrossRoad_11CBlack_11BBlack";
import CrossRoad_16DBlack_16CBlack from "./crossroads/CrossRoad_16DBlack_16CBlack";
import CrossRoad_16ARed_16CBlack from "./crossroads/CrossRoad_16ARed_16CBlack";
import CrossRoad_16ARed_16BBlack from "./crossroads/CrossRoad_16ARed_16BBlack";
import CrossRoad_14BBlue_14ABlue from "./crossroads/CrossRoad_14BBlue_14ABlue";
import CrossRoad_15EBlue_15DRed_SBlue from "./crossroads/CrossRoad_15EBlue_15DRed_SBlue";
import CrossRoad_15DRed_14BBlue from "./crossroads/CrossRoad_15DRed_14BBlue";
import CrossRoad_14ABlue_22ABlack from "./crossroads/CrossRoad_14ABlue_22ABlack";
import CrossRoad_14ABlue_SBlue from "./crossroads/CrossRoad_14ABlue_SBlue";
import CrossRoad_5KBlue_5GRed_5FBlack from "./crossroads/CrossRoad_5KBlue_5GRed_5FBlack";
import CrossRoad_5KBlue_5EBlack from "./crossroads/CrossRoad_5KBlue_5EBlack";
import Crossroad_JBlue_13EBlue from "./crossroads/Crossroad_JBlue_13EBlue";
import Crossroad_13ARed_13CRed from "./crossroads/Crossroad_13ARed_13CRed";
import Crossroad_13ARed_13BRed from "./crossroads/Crossroad_13ARed_13BRed";
import Crossroad_9ABlue_13CRed from "./crossroads/Crossroad_9ABlue_13CRed";
import Crossroad_9ABlue_13BRed from "./crossroads/Crossroad_9ABlue_13BRed";
import CrossRoad_1ARed_1BBlack_1EBlue from "./crossroads/CrossRoad_1ARed_1BBlack_1EBlue";
import { TRACK_STATE_DIFFICULTY } from "../config/constants";
import CrossRoad1CBlue1BBlack1EBlue from "./crossroads/CrossRoad1CBlue1BBlack1EBlue";
import CrossRoad11ARed11BBlack from "./crossroads/CrossRoad11ARed11BBlack";
import CrossRoad12BBlue12CRed12ARed from "./crossroads/CrossRoad12BBlue12CRed12ARed";
import CrossRoad5HBlack5KBlue from "./crossroads/CrossRoad5HBlack5KBlue";
import CrossRoad2CBlue2BRed from "./crossroads/CrossRoad2CBlue2BRed";
import CrossRoad2CBlueBBlue from "./crossroads/CrossRoad2CBlueBBlue";
import CrossRoad2CBlue2ARed from "./crossroads/CrossRoad2CBlue2ARed";
import CrossRoad5FBlack5EBlack5DRed from "./crossroads/CrossRoad5FBlack5EBlack5DRed";
import CrossRoad1CBlueConnectors from "./crossroads/CrossRoad1CBlueConnectors";
import CrossRoad7ABlue7BBlue from "./crossroads/CrossRoad7ABlue7BBlue";
import CrossRoad14BBlue22CBlue from "./crossroads/CrossRoad14BBlue22CBlue";
import CrossRoad9ABlue13DRed from "./crossroads/CrossRoad9ABlue13DRed";
import CrossRoad8DBlue8ARed from "./crossroads/CrossRoad8DBlue8ARed";
import CrossRoad11DRed11BBlack from "./crossroads/CrossRoad11DRed11BBlack";
import CrossRoad11ERed11BBlack from "./crossroads/CrossRoad11ERed11BBlack";
import CrossRoad2CBlue3ABlue from "./crossroads/CrossRoad2CBlue3ABlue";
import CrossRoad from "./UI/Crossroad";

class CrossRoadsList extends PureComponent {
	commonRule = () => this.props.tracksState === TRACK_STATE_DIFFICULTY;

	// debugRule = () => false;

	render() {
		const { tracksData } = this.props;
		return (
			<>
				{(crossroad1CBlue1ARedShow(tracksData) || this.commonRule()) && <CrossRoad_1CBlue_1ARed/>}
				{(crossroad2CBlue2BRed(tracksData) || this.commonRule()) && <CrossRoad_2CBlue_2BRed/>}
				{(crossroadCondition(tracksData, ['5GRed', '5KBlue']) || this.commonRule()) &&
					<CrossRoad5KBlue5GRed/>}
				{(crossroad5KBlue5CRed(tracksData) || this.commonRule()) && <CrossRoad_5K_5C/>}
				{(crossroad5ABlue5DRed(tracksData) || this.commonRule()) && <CrossRoad_5ABlue_5DRed/>}
				{(crossroad5CRedFBlueGBlue5BBlue5ABlue(tracksData) || this.commonRule()) &&
					<CrossRoad_5CRed_FBlue_GBlue_5BBlue_5ABlue/>}
				{(crossroad8CRed8DBlue(tracksData) || this.commonRule()) && <CrossRoad_8CRed_8DBlue/>}
				{(crossroad8BRed8DBlue8CRed(tracksData) || this.commonRule()) && <CrossRoad_8BRed_8CRed_8DBlue/>}
				{(crossroad12ARed12DRed(tracksData) || this.commonRule()) && <CrossRoad_12ARed_12DRed/>}
				{(crossroad12CRed12DRed(tracksData) || this.commonRule()) && <CrossRoad_12CRed_12DRed/>}
				{(crossroad12BBlue12DRed(tracksData) || this.commonRule()) && <CrossRoad_12BBlue_12DRed/>}
				{(crossroad11DRed11CBlack(tracksData) || this.commonRule()) && <CrossRoad_11DRed_11CBlack/>}
				{(crossroad11FBlue11CBlack(tracksData) || this.commonRule()) && <CrossRoad_11FBlue_11CBlack/>}
				{(crossroad11FBlue11ARed(tracksData) || this.commonRule()) && <CrossRoad11FBlue11ARed/>}
				{(crossroad11DRed11FBlue(tracksData) || this.commonRule()) && <CrossRoad_11DRed_11FBlue/>}

				{(
					crossroadCondition(tracksData, ['11FBlue', '11CBlack'], false, '11BBlack') ||
					this.commonRule()
				) && <CrossRoad_11CBlack_11BBlack/>}

				{(crossroad16DBlack16CBlack(tracksData) || this.commonRule()) && <CrossRoad_16DBlack_16CBlack/>}
				{(crossroad16ARed16CBlack(tracksData) || this.commonRule()) && <CrossRoad_16ARed_16CBlack/>}
				{(crossroad16ARed16BBlack(tracksData) || this.commonRule()) && <CrossRoad_16ARed_16BBlack/>}
				{(crossroad14BBlue14ABlue(tracksData) || this.commonRule()) && <CrossRoad_14BBlue_14ABlue/>}
				{(crossroad15EBlue15DRedSBlue(tracksData) || this.commonRule()) && <CrossRoad_15EBlue_15DRed_SBlue/>}
				{(crossroad15DRed14BBlue(tracksData) || this.commonRule()) && <CrossRoad_15DRed_14BBlue/>}
				{(crossroad14ABlue22ABlack(tracksData) || this.commonRule()) && <CrossRoad_14ABlue_22ABlack/>}
				{(crossroad14ABlueSBlue(tracksData) || this.commonRule()) && <CrossRoad_14ABlue_SBlue/>}
				{(crossroad5KBlue5GRed5FBlack(tracksData) || this.commonRule()) && <CrossRoad_5KBlue_5GRed_5FBlack/>}
				{(crossroad5KBlue5EBlack(tracksData) || this.commonRule()) && <CrossRoad_5KBlue_5EBlack/>}
				{(crossroadJBlue13EBlue(tracksData) || this.commonRule()) && <Crossroad_JBlue_13EBlue/>}
				{(crossroad13ARed13CRed(tracksData) || this.commonRule()) && <Crossroad_13ARed_13CRed/>}
				{(crossroad13ARed13BRed(tracksData) || this.commonRule()) && <Crossroad_13ARed_13BRed/>}

				{(crossroadCondition(tracksData, ['1ARed', '1BBlack', '1EBlue']) || this.commonRule()) &&
					<CrossRoad_1ARed_1BBlack_1EBlue/>}
				{(crossRoad1CBlue1BBlack1EBlue(tracksData) || this.commonRule()) && <CrossRoad1CBlue1BBlack1EBlue/>}

				{(crossroad2CBlue2BRed(tracksData) || this.commonRule()) && <CrossRoad2CBlue2BRed/>}
				{(crossroadCondition(tracksData, ['2CBlue', 'BBlue']) || this.commonRule()) && <CrossRoad2CBlueBBlue/>}
				{(crossroadCondition(tracksData, ['2CBlue', '2ARed']) || this.commonRule()) && <CrossRoad2CBlue2ARed/>}
				{(crossroadCondition(tracksData, ['12BBlue', '12CRed', '12ARed']) || this.commonRule()) &&
					<CrossRoad12BBlue12CRed12ARed/>}
				{(crossroadCondition(tracksData, ['11ARed', '11BBlack']) || this.commonRule()) && <CrossRoad11ARed11BBlack/>}
				{(crossroadCondition(tracksData, ['11DRed', '11BBlack']) || this.commonRule()) && <CrossRoad11DRed11BBlack/>}
				{(crossroadCondition(tracksData, ['11ERed', '11FBlue', '11DRed', '11CBlack', '11BBlack']) || this.commonRule()) &&
					<CrossRoad11ERed11BBlack/>}
				{(crossroadCondition(tracksData, ['5HBlack', '5KBlue']) || this.commonRule()) && <CrossRoad5HBlack5KBlue/>}

				{(crossroadCondition(tracksData, ['5FBlack', '5EBlack', '5DRed']) || this.commonRule()) &&
					<CrossRoad5FBlack5EBlack5DRed/>}

				<CrossRoad1CBlueConnectors/>

				{(crossroadCondition(tracksData, ['7ABlue', '7BBlue']) || this.commonRule()) && <CrossRoad7ABlue7BBlue/>}
				{(crossroadCondition(tracksData, ['14BBlue', '22CBlue']) || this.commonRule()) && <CrossRoad14BBlue22CBlue/>}
				{(crossroadCondition(tracksData, ['8DBlue', '8ARed']) || this.commonRule()) && <CrossRoad8DBlue8ARed/>}
				{(crossroadCondition(tracksData, ['2CBlue', '3ABlue']) || this.commonRule()) && <CrossRoad2CBlue3ABlue/>}


				{(crossroadCondition(tracksData, ['9ABlue', '13DRed']) || this.commonRule()) && <CrossRoad9ABlue13DRed/>}
				{(crossroad9ABlue13BRed(tracksData) || this.commonRule()) && <Crossroad_9ABlue_13CRed/>}
				{(crossroad9ABlue13CRed(tracksData) || this.commonRule()) && <Crossroad_9ABlue_13BRed/>}
			</>
		)
	}
}

CrossRoadsList.propTypes = {
	tracksData: PropTypes.object.isRequired,
	tracksState: PropTypes.string.isRequired
};

export default CrossRoadsList;
